import axios, { getEnv } from './api';

const DiagnosticoService = {
  buscarDiagnosticos: async (mapParams, filters) => {
    try {
      const res = await axios.post(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/faqs/consultar${mapParams}`,
        filters
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  saveDiagnostico: async (diagnostico) => {
    try {
      const res = await axios.post(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/faqs`,
        diagnostico
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  updateDiagnostico: async (diagnostico) => {
    try {
      const res = await axios.put(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/faqs`,
        diagnostico
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  deleteDiagnostico: async (idDiagnostico) => {
    try {
      const res = await axios.delete(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/faqs/${idDiagnostico}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  updateStatus: async (idDiagnostico, status) => {
    try {
      const res = await axios.put(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/faqs/${idDiagnostico}/status/${status}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getOptions: async (isOptimized = false) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/faqs/opcoes?consulta=${isOptimized}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getAnalytics: async () => {
    try {
      const res = await axios.get(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/faqs/status-quantidade`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getDataByType: async (tipo) => {
    try {
      const res = await axios.get(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/faqs/asssuntos/${tipo}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  orderFaq: async (orderedValues) => {
    try {
      const res = await axios.put(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/faqs/organizar`,
        orderedValues
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  orderAssuntos: async (orderedValues) => {
    try {
      const res = await axios.put(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/faqs/assuntos/organizar`,
        orderedValues
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getServiceData: async (codDiagnosticoSASPE) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/faqs/previsualizar/${codDiagnosticoSASPE}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  addAssunto: async (assunto) => {
    try {
      const res = await axios.post(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/faqs/assuntos`,
        assunto
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getAssuntos: async () => {
    try {
      const res = await axios.get(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/faqs/assuntos`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
};

export default DiagnosticoService;
